import { useState } from "react";
import { Col, Input, Label } from "reactstrap";
import { Btn, H3, P } from "../../AbstractElements";
import { CalendarFilter, DraggableEvents, Href, RemoveAfterDrop } from "../../Constant";
import { CalendarProp } from "../../Type/CalenderType";

const CalendarEvents = ({ state }: CalendarProp) => {
  const [openCalender, setOpenCalender] = useState(false);

  return (
    <Col xxl="3" className="box-col-4e">
      <div className="md-sidebar mb-3">
        <Btn tag="a" color="primary" className="md-sidebar-toggle" href={Href} onClick={() => setOpenCalender(!openCalender)}>
          {CalendarFilter}
        </Btn>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${openCalender ? "open" : ""}`}>
          <div id="external-events">
            <H3>{DraggableEvents}</H3>
            <div id="external-events-list" className="mt-3">
              {state.events.map((event, index) => (
                <div className={`fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event`} title={event.title} key={index}>
                  <div className="fc-event-main">
                    <i className={`me-2 ${event.icon}`}></i>
                    {event.title}
                  </div>
                </div>
              ))}
            </div>
            <P>
              <Input className="checkbox_animated" id="drop-remove" type="checkbox" />
              <Label htmlFor="drop-remove" check>
                {RemoveAfterDrop}
              </Label>
            </P>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default CalendarEvents;
